import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue';
import { Sector } from '@/shared/dtos/sector';
import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';



@Module({
    namespaced: true,
    name: 'SectorModule',
    store,
    dynamic: true,
})

class SectorModule extends VuexModule implements BaseModule {
    public sectors: Sector[] = [];

    @Mutation
    public resetState(): void {
        this.sectors = [];
    }

    @Action
    public async getSectors() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.sector);
        this.context.commit('updateSectors', res);
    }

    @Mutation
    public updateSectors(items: Sector[]) {
        this.sectors = items;
    }

    @Action
    public async insertarSector(item: Sector){
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.post(API.sector, item, false);
        this.context.dispatch('getSectors');
    }

    @Action
    public async modificarSector(item: Sector){
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.put(API.sector, item, false);
        this.context.dispatch('getSectors');
    }

    @Action
    public async eliminarSector(id: number){
        if (!itiTokenService.hasToken()) { return; }
        const apiDeleteSector = ItiString.Format(API.sectorDetail, id);
        const res = await itiHttpService.delete(apiDeleteSector, id, false);
        this.context.dispatch('getSectors');
    }
}

export default getModule(SectorModule);